import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import DatabaseTableView from './Table';
import DatabaseController from '../controllers/Database';
import getPlugins from '../plugins';

var DatabaseContainer =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(DatabaseContainer, _React$PureComponent);

  function DatabaseContainer(props, context) {
    var _this;

    _classCallCheck(this, DatabaseContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DatabaseContainer).call(this, props, context));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (change) {
      _this.props.onChange(change);
    });

    _this.plugins = getPlugins(props);
    _this.controller = new DatabaseController({
      onChange: _this.onChange,
      plugins: _this.plugins,
      readOnly: _this.props.readOnly,
      value: _this.props.value,
      selection: _this.props.selection
    });
    return _this;
  }

  _createClass(DatabaseContainer, [{
    key: "render",
    value: function render() {
      if (!this.props.value) {
        return null;
      }

      this.controller.setValue(this.props.value);
      this.controller.setCurrentUserId(this.props.currentUserId);
      this.controller.setReadOnly(this.props.readOnly);
      return React.createElement(DatabaseTableView, {
        database: this.controller,
        value: this.controller.value,
        selection: this.controller.selection,
        data: this.controller.data
      });
    }
  }]);

  return DatabaseContainer;
}(React.PureComponent);

_defineProperty(DatabaseContainer, "propTypes", {
  databaseNoteId: PropTypes.string.isRequired,
  currentUserId: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired,
  value: PropTypes.object,
  selection: PropTypes.object,
  setActiveModal: PropTypes.func.isRequired
});

export default DatabaseContainer;